module.exports = __webpack_public_path__ + "static/media/29-10.05987966.mp3";